
<template>
  <div class="apply">
    <div class="type-form">
      <div class="progress-top-wrapper">
        <div class="progress-bg">
          <div
            class="fill"
            :style="{
              width: (formAns.length * 100) / (questions.length - 2) + '%',
            }"
          />
        </div>
      </div>
      <swiper class="swiper" :options="swiperOption" ref="swiper">
        <swiper-slide v-for="(question, i) in questions" :key="i">
          <div class="slide" :style="'background-color:' + background">
            <Splash
              v-if="question.type === 'splash'"
              :index="index"
              @nextSlide="nextScreen"
              :splashImg="splashImg"
              :text="splashText"
              :button-text="splashButtonText"
            />
            <Question
              v-else
              :question="question"
              :slide="index"
              :index="i"
              @answered="saveAnswer"
              @submitForm="submitForm"
            />
          </div>
        </swiper-slide>
      </swiper>

      <Progress
        @next="nextScreen"
        @prev="prevScreen"
        v-if="index !== 0"
        class="progress-tf"
      />
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper.scss";
import Splash from "./layout/Splash";
import Question from "./questions/Question";
import DefaultFormShort from "./default/DefaultFormShort";
import Progress from "./layout/Progress";
import {mapGetters} from "vuex";
import axios from "axios";
import RecordViews from "@/mixins/RecordViews";
export default {
  name: "swiper-example-vertical",
  title: "SavCo Form",
  mixins: [RecordViews],
  components: {
    Swiper,
    SwiperSlide,
    Splash,
    Question,
    Progress,
  },
  created() {
    axios.get("https://api.ipify.org?format=json").then(res => {
      this.res = res;
    });
  },
  mounted() {
    if (this.splash.type === "image") {
      this.splashImg = require(`@/assets/${this.splash.path}`);
    }
  },
  props: {
    background: {
      type: String,
      default: "#F3F6F9",
    },
    form: {
      type: Object,
      default: () => {
        return DefaultFormShort;
      },
    },
    swiperOption: {
      type: Object,
      default: () => {
        return {
          allowTouchMove: false,
          direction: "vertical",
        };
      },
    },
    lottie: {
      type: Object,
      default: () => {
        return {
          src: "assets/lotties/blog-management.json",
          alt: "Standard",
          width: 200,
          height: 200,
        };
      },
    },
    progressBar: {
      /* @TODO- HANDLE PROGRESS BAR */ type: Object,
      default: () => {
        return {
          position: "top",
          color: "#557efb",
        };
      },
    },
    splash: {
      type: Object,
      default: () => {
        return {
          type: "image",
          path: "img/webSessions.png",
          text:
            "Apply to become a guide with JourneyBinder. Join us as we provide NOWledge-share to the masses.",
        };
      },
    },
  },
  data() {
    return {
      index: 0,
      splashImg: null,
      formAns: [],
      completed: 0,
      state: "splash",
      res: null
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    splashImage() {
      return this.splashImg;
    },
    splashText() {
      return this.form.splash
        ? this.form.splash.callToAction
        : "I have a few questions";
    },
    splashButtonText() {
      return this.form.splash ? this.form.splash.button : "Start";
    },
    questions() {
      return Array.isArray(this.form.questions) ? this.form.questions : [];
    },
  },
  methods: {
    nextScreen() {
      this.completed = this.index;
      this.index += 1;
      this.$refs.swiper.$swiper.slideNext(600);
    },
    prevScreen() {
      this.index -= 1;
      this.completed = this.index;
      this.$refs.swiper.$swiper.slidePrev(600);
    },
    saveAnswer(val) {
      let flag = true;
      this.formAns.forEach((item) => {
        if (item.index === val.index) {
          flag = false;
        }
      });
      if (flag) this.formAns.push(val);
      this.nextScreen();
    },
    submitForm() {
      let totalQuestions = this.questions.length - 2;
      if (this.formAns.length === totalQuestions) {

        this.formComplete(this.formAns);

        this.$emit("complete", this.formAns);
      } else {
        for (let i = 1; i <= totalQuestions; i++) {
          let flag = true;
          this.formAns.forEach((item) => {
            if (item.index === i) {
              flag = false;
            }
          });
          if (flag) {
            this.index = i;
            this.$refs.swiper.$swiper.slideTo(i, 600);
            break;
          }
        }
      }
    },
    formComplete(dataFromForm) {
      const sessionCookie = this.checkSession("session");

      const data = {
        form: {
          user: this.user ? this.user.uid : null,
          cookie: sessionCookie,
          ip: this.res ? this.res.data ? this.res.data.ip : this.res : null,
          data: dataFromForm
        },
        form_name: this.form.formId ? this.form.formId : 'default'
      }

      this.$store.dispatch("user/saveForm", data).then(()=>{
        this.$emit("complete", dataFromForm);
      });
    }
  },
  watch: {
    index() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-top-wrapper {
  position: fixed;
  top: 10px;
  @media (max-width: 991px) {
    top: 114px;
  }
  left: 0;
  width: 100%;
  z-index: 2;
  .progress-bg {
    height: 12px;
    width: 100%;
    //border-radius: 26px;
    position: relative;
    .fill {
      background: #557efb;
      //border-radius: 26px;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 0;
    }
  }
}

.apply {
  padding-top: 108px;
  @media (max-width: 991px) {
    padding-top: 114px;
  }
  .type-form {
    position: relative;

    height: calc(100vh - 100px);
    @media (max-width: 600px) {
      height: 120vh;
    }
    overflow: hidden;
    position: relative;
    .progress-tf {
      position: absolute;
      bottom: 20px;
      width: 100%;
      left: 0%;
      @media (max-width: 600px) {
        top: unset;
        position: fixed;
        left: 0;
        bottom: 0;
        height: 60px;
        width: 100%;
        background-color: #fff;
      }
    }
    .slide {
      min-height: calc(100vh - 100px);
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 600px) {
        height: 120vh;
        align-items: flex-start;
        padding: 30px 15px;
      }
    }
  }
}
</style>
